<style>
.setpsd {
  box-sizing: border-box;
  padding: 0 80px;
  background: #fff;
  overflow: hidden;
  margin-top: 25px;
  padding-bottom: 300px;
  width: 1200px;
  height: 730px;
}

.set-form {
  margin-top: 100px;
}

.set-input {
  width: 360px !important;
}

.setpsd .el-form-item {
  margin-bottom: 25px;
}

.setpsd .el-input__inner {
  height: 45px;
  line-height: 45px;
  border-radius: 23px;
}
.setpsd .sendCode {
  width: 140px;
  height: 45px;
  line-height: 45px;
  display: inline-block;
  position: absolute;
  margin-left: -140px;
  border-radius: 25px;
  color: #fff;
  text-align: center;
  cursor: pointer;
}
.setpsd .sendCode.btn-green {
  background: #2ecfa7;
}
.setpsd .sendCode.btn-grey {
  background: #abb1c3;
}

.set-submit {
  margin-top: 45px;
  margin-left: 250px;
}

.update-psd {
  font-size: 20px;
  font-weight: bold;
  text-align: center;
  margin-bottom: 30px;
}

.setpsd .el-form-item__label,
.setpsd .el-form-item__error {
  margin-left: 250px;
}

.set-submit .el-button--primary {
  font-size: 16px;
  width: 120px;
  height: 40px;
  border-radius: 20px;
}

.set-submit .el-button + .el-button {
  border-radius: 20px;
  width: 100px;
}
.el-button.redBtn {
  background: #f83b56;
  color: #fff;
}

.el-button.darkBtn {
  background: #3b404f;
  color: #fff;
}
/* 验证 */
.setpsd .sliderVer {
  display: inline-block;
  width: 360px;
}
.setpsd .sliderVer .el-slider__runway,
.setpsd .sliderVer .el-slider__bar {
  height: 45px;
  margin: 0;
  background: none;
  border: 1px solid #dcdfe6;
  border-radius: 23px;
}
.setpsd .sliderVer .el-slider__bar {
  border: none;
}
.setpsd .sliderVer .el-slider__button-wrapper {
  height: 45px;
  width: 45px;
  top: 0;
}
.setpsd .sliderVer .el-slider__button {
  width: 100%;
  height: 100%;
  border-radius: 0;
  content: ">";
  color: #dcdfe6;
  border: 1px solid #dcdfe6;
  background: none;
}
.setpsd .sliderVer .el-slider__button-wrapper::after {
  content: ">>";
  line-height: 45px;
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
}
</style>
<template>
  <div>
    <HeaderForget v-if="$route.params.tel === 'forget'"/>
    <Header v-else/>
    <div class="content setpsd">
        <div class="staffId" v-if="$route.params.tel === 'forget' && oneFlag">
          <el-form :model="ruleForm2" status-icon :rules="rules2" ref="ruleForm2" label-width="120px"
               class="demo-ruleForm set-form">
               <div class="update-psd">{{$route.params.tel === 'forget' ? '忘记密码' : '重置密码'}}</div>
            <el-form-item label="登录账号：" prop="staffId">
              <el-input type="text" autocomplete="off" v-model="ruleForm2.staffId" auto-complete="off" class="set-input" placeholder="请输入登录账号"></el-input>
            </el-form-item>
            <!-- <el-form-item label="滑块验证码：" prop="value1">
              <div class="sliderVer"><el-slider v-model="value1"></el-slider></div>
            </el-form-item> -->
            <el-form-item class="set-submit">
              <el-button class="redBtn" @click="next">下一步</el-button>              
            </el-form-item>
            <el-form-item label-width="0" style="margin-left:250px">
              <div class="red">老板帐号找回密码，请在综合服务管理平台（<a class="blue" href="http://is.meishealth.com/#/" target="_blank">is.meishealth.com</a>）找回密码。</div>
            </el-form-item>
          </el-form>
        </div>
        <el-form :model="ruleForm2" status-icon :rules="rules2" ref="ruleForm2" label-width="120px"
               class="demo-ruleForm set-form" v-else>
               <div class="update-psd">{{$route.params.tel === 'forget' ? '忘记密码' : '重置密码'}}</div>
        <div class="two" >
          <el-form-item label="手机号：" prop="phone" v-if="$route.params.tel === 'forget'">
              <span>{{ruleForm2.phone}}</span>
          </el-form-item>
          <el-form-item label="短信验证码：" prop="vcode" required>
              <el-input type="text" autocomplete="off" v-model="ruleForm2.vcode" auto-complete="off" class="set-input" placeholder="请输入短信验证码"></el-input>
              <div class="sendCode btn-green" @click="sendVcode">发送验证码</div>
          </el-form-item>
          <el-form-item label="新密码：" prop="pass" required>
            <el-input type="password" autocomplete="off" v-model="ruleForm2.pass" auto-complete="off" class="set-input"
                      placeholder="请输入新密码"></el-input>
          </el-form-item>
          <el-form-item label="请确认：" prop="checkPass" required v-if="$route.params.tel !== 'forget'">
            <el-input type="password" autocomplete="off" v-model="ruleForm2.checkPass" auto-complete="off" class="set-input" placeholder="请再次输入新密码"></el-input>
          </el-form-item>
          <el-form-item class="set-submit">
            <el-button class="redBtn" @click="submitForm('ruleForm2')">确认修改</el-button>
            <el-button class="darkBtn" @click="resetForm('ruleForm2')" plain>取消</el-button>
          </el-form-item>
          </div>
        </el-form>
    </div>
    <Footer/>
  </div>
</template>

<script>
import Header from "@/components/common/Header";
import Footer from "@/components/common/Footer";
import HeaderForget from '@/components/common/HeaderForget'
import { sendCode, resetStaffPsd, queryStaffPhoneByStaffId } from "@/api";
import CryptoJS from 'crypto-js'

export default {
  components: {
    Header,
    Footer,
    HeaderForget
  },
  data() {
    var checkoldPass = (rule, value, callback) => {
      var reg = /^\+?[1-9][0-9]*$/;
      if (value === "") {
        callback(new Error("请输入验证码"));
      } else if (!reg.test(value)) {
        callback(new Error("验证码格式为数字，请输入正确的验证码"));
      } else if (value.length < 6) {
        callback(new Error("验证码不正确"));
      } else if (value.length > 6) {
        callback(new Error("验证码长度只可以是6位"));
      } else {
        callback();
      }
    };
    var validatePass = (rule, value, callback) => {
      var reg = /^[A-Za-z0-9]{1,30}$/;
      if (value === "") {
        callback(new Error("请输入新密码"));
      } else if (!reg.test(value)) {
        callback(new Error("密码格式为字母和数字，请设置正确格式的密码"));
      } else if (value.length < 6) {
        callback(new Error("密码长度最小6位"));
      } else if (value.length > 16) {
        callback(new Error("密码长度最大16位"));
      } else {
        if (this.ruleForm2.checkPass !== "") {
          this.$refs.ruleForm2.validateField("checkPass");
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      var reg = /^[A-Za-z0-9]{1,30}$/;
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.ruleForm2.pass) {
        callback(new Error("两次输入密码不一致!"));
      } else if (!reg.test(value)) {
        callback(new Error("密码格式为字母和数字，请设置正确格式的密码"));
      } else if (value.length < 6) {
        callback(new Error("密码长度最小6位"));
      } else if (value.length > 16) {
        callback(new Error("密码长度最大16位"));
      } else {
        callback();
      }
    };
    return {
      ruleForm2: {
        phone: "",
        staffId: "",
        vcode: "",
        pass: "",
        checkPass: ""
      },
      phone: "",
      value1: 0,
      oneFlag: true,
      clickSwitch: true,
      rules2: {
        staffId: [
          { required: true, message: "请输入登录账号", trigger: "blur" }
        ],
        vcode: [{ validator: checkoldPass, trigger: "blur" }],
        pass: [{ validator: validatePass, trigger: "blur" }],
        checkPass: [{ validator: validatePass2, trigger: "blur" }]
      }
    };
  },
  created() {
    this.oneFlag = true;
  },
  activated() {
    this.oneFlag = true;
  },
  methods: {
    operaEntryDES(message) {
      var keyHex = CryptoJS.enc.Utf8.parse("VIP20198888*7*6*5*4**88882088VIP");
      var encrypted = CryptoJS.TripleDES.encrypt(message, keyHex, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
      });
      return encrypted.toString();
    },
    formatTooltip(val) {
      // 滑块验证
      return val / 100;
    },
    next() {
      // 下一步
      this.$refs.ruleForm2.validate(valid => {
        if (valid) {
          queryStaffPhoneByStaffId({
            staffId: this.ruleForm2.staffId
          }).then(res => {
            if (res.code == 1) {
              this.oneFlag = false;
              this.ruleForm2.phone =
                res.data.staffPhone.substr(0, 3) +
                "****" +
                res.data.staffPhone.substr(7);
              this.phone = res.data.staffPhone;
            } else {
              this.$message({
                message: res.msg,
                type: "error"
              });
            }
          });
        }else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    sendVcode() {
      //   发送验证码
      if (this.clickSwitch) {
        let sec = 60;

        sendCode({
          phone:
            this.$route.params.tel === "forget"
              ? this.phone
              : this.$route.params.tel
        }).then(res => {
          if (res.code == 1) {
            $(".sendCode")
              .removeClass("btn-green")
              .addClass("btn-grey");
            $(".sendCode").html("重新发送(" + sec + "S)");

            let setTime = setInterval(() => {
              if (sec <= 0) {
                clearInterval(setTime);
                $(".sendCode").html("发送验证码");
                $(".sendCode")
                  .removeClass("btn-grey")
                  .addClass("btn-green");
                this.clickSwitch = true;
                return;
              } else {
                sec--;
                $(".sendCode").html("重新发送(" + sec + "S)");
                this.clickSwitch = false;
              }
            }, 1000);
          }
          this.$message({
            type: res.code == 1 ? "success" : "error",
            message: res.msg
          });
        });
      }
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let postData = {
            smsCode: this.ruleForm2.vcode,
            staffId: this.ruleForm2.staffId,
            password: this.operaEntryDES(this.ruleForm2.pass),
            staffPhone: this.phone
          };

          const date = resetStaffPsd(postData);
          date
            .then(res => {
              this.$message({
                message: res.msg,
                type: res.code == 1 ? "success" : "error"
              });
              if (res.code == 1) {
                this.$refs[formName].resetFields();
                this.$router.push("/");
              }
            })
            .catch(error => {
              this.$message({
                message: "网络连接失败，请稍后再试",
                type: "error"
              });
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    }
  }
};
</script>





// WEBPACK FOOTER //
// src/components/home/resetPwd.vue